import React from "react";
import BorderedLogo from '../../../../Resources/Logo/LogoBordered.png';

function STCLogoBordered(props){

    return(
        <img
            alt={'STCBorderedLogo'}
            style={props.style}
            className={props.className}
            src={BorderedLogo}
        />
    )
}
export default STCLogoBordered;